import { useState } from 'react';
import Image from 'next/image';
import classnames from 'classnames';
import FormInput, { Props as FormInputProps } from '../FormInput/FormInput';

type Props = {
  className?: string;
  newPassword?: boolean;
  showError?: boolean;
  name?: string;
  placeholder?: string;
} & Omit<FormInputProps, 'name'>;

const FormPasswordInput = ({
  className,
  newPassword,
  label,
  background,
  border,
  size,
  control,
  onKeyUp,
  placeholder,
  showError = false,
  name = 'password',
}: Props) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  return (
    <div className={`relative flex w-full flex-col ${className}`}>
      {/* password */}
      <div className="flex justify-between">
        {label && <p className="mb-2 text-small font-bold">{label}</p>}
      </div>
      <div className="relative">
        <FormInput
          border={border}
          name={name}
          control={control}
          type={showPassword ? 'text' : 'password'}
          autoComplete={newPassword ? 'new-password' : 'current-password'}
          inputClassName="pr-10 pl-3"
          placeholder={placeholder}
          background={background}
          size={size}
          showError={showError}
          onKeyUp={onKeyUp}
          requirements={
            newPassword
              ? [
                  'password.minimum_length',
                  'password.no_whitespace',
                  'password.lowercase_uppercase_number_special_character',
                ]
              : []
          }
        />
        <div
          className={classnames('absolute right-4', {
            'top-3.5': size === 'large',
            'top-2.5': size === 'medium',
            'top-1.5': size === 'small',
          })}
          onClick={() => setShowPassword(!showPassword)}
          role="button"
          tabIndex={0}
          onKeyPress={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <Image src="/eye-opened.svg" alt="eye opened" width={20} height={20} />
          ) : (
            <Image src="/eye-closed.svg" alt="eye closed" width={20} height={20} />
          )}
        </div>
      </div>
    </div>
  );
};

FormPasswordInput.displayName = 'FormPasswordInput';

export default FormPasswordInput;
